export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Показано:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["всего"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["На странице"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Показать"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Результаты"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["из"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сделка"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сделок"])}
}